export enum SubscriptionType {
  SUBSCRIPTION_EDUCATOR = "SUBSCRIPTION_EDUCATOR",
  SUBSCRIPTION_USER = "SUBSCRIPTION_USER",
}
